import type { SVGProps } from "react";
import { memo } from "react";
const CloudControlAPI = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#2E27AD" />
        <stop offset="100%" stopColor="#527FFF" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M14.053 46.914a7.1 7.1 0 0 1 1.712-5.556 6.94 6.94 0 0 1 5.186-2.34h24.506l-5.293 5.292 1.414 1.415 7-7a1 1 0 0 0 0-1.415l-7-7-1.414 1.415 5.293 5.293H20.951a8.94 8.94 0 0 0-6.683 3.014 9.1 9.1 0 0 0-2.2 7.123c.544 4.483 4.506 7.863 9.216 7.863h1.667v-2h-1.667c-3.7 0-6.809-2.625-7.23-6.104m53.945-2.644c0 9.897-9.949 10.738-10.049 10.745l-27.368.002 5.293 5.293-1.414 1.415-7-7a1 1 0 0 1 0-1.415l7-7 1.414 1.415-5.293 5.293h27.295c.26-.023 8.122-.726 8.122-8.748 0-1.464-.274-2.784-.814-3.922-.696-1.465-1.84-2.659-3.399-3.548a11.2 11.2 0 0 0-1.876-.846 12.3 12.3 0 0 0-1.973-.512 1 1 0 0 1-.82-1.135l.005-.034a9 9 0 0 0-.256-2.125c-.534-2.09-1.902-3.498-3.754-3.859-1.794-.352-3.669.395-4.777 1.897a1 1 0 0 1-1.748-.261c-.823-2.333-2.013-4.294-3.539-5.828-1.873-1.885-7.016-5.938-14.27-2.855-4.195 1.781-7.48 6.914-7.48 11.683h-2c0-5.603 3.738-11.418 8.698-13.524 5.815-2.468 11.971-1.24 16.47 3.285 1.398 1.406 2.544 3.113 3.42 5.09 1.551-1.28 3.615-1.84 5.608-1.45 2.604.508 4.588 2.5 5.31 5.328.158.623.258 1.288.298 1.985q.741.173 1.467.426c.783.273 1.526.61 2.208.998 1.922 1.096 3.34 2.585 4.214 4.427.67 1.408 1.008 3.017 1.008 4.78"
      />
    </g>
  </svg>
);
const Memo = memo(CloudControlAPI);
export default Memo;
